import styled, { css } from 'styled-components';

export const SelectedWrapper = styled.div`
    display: flex;
    justify-content: left;
    align-items: center;
    gap: 10px;
    user-select: none;
`;

type SelectedCopyProps = {
    $selectedAllItems?: boolean;
    $canToggle: boolean;
};

export const SelectedCopy = styled.span<SelectedCopyProps>`
    white-space: nowrap;
    ${({ $canToggle }) =>
        $canToggle &&
        css`
            cursor: pointer;
            text-decoration: underline;
        `}
`;
